import { render, staticRenderFns } from "./AdministradorDeVacantes.vue?vue&type=template&id=f96755fe&scoped=true"
import script from "./AdministradorDeVacantes.vue?vue&type=script&lang=js"
export * from "./AdministradorDeVacantes.vue?vue&type=script&lang=js"
import style0 from "./AdministradorDeVacantes.vue?vue&type=style&index=0&id=f96755fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96755fe",
  null
  
)

export default component.exports